export default {
  on: {
    pageInit: function () {
      var root = this.$el && this.$el[0] ? this.$el[0] : document;
      var input = root.querySelector('#amount-invest');
      var returns = root.querySelector('.iv__returns');
      var rateEl = root.querySelector('.iv__rate');
      var dailyEl = root.querySelector('.iv__return-daily');
      var weekEl = root.querySelector('.iv__week');
      var monthEl = root.querySelector('.iv__month');
      var maxroiEl = root.querySelector('.iv__maxroi');
      var capdaysEl = root.querySelector('.iv__capdays');
      var capnoteEl = root.querySelector('.iv__capnote');
      var note = root.querySelector('.totalReturn');
      var submit = root.querySelector('.investNowBTN');
      var chipWrap = root.querySelector('.iv__chips');
      var minNote = root.querySelector('.iv__min-note');
      var planList = root.querySelector('.iv__plan-list');
      var planRules = root.querySelector('.iv__plan-rules');
      var heroRoi = root.querySelector('.iv__hero-roi');
      var heroCap = root.querySelector('.iv__hero-cap');
      var heroPay = root.querySelector('.iv__hero-payout');
      var weekLbl = root.querySelector('.iv__week-lbl');
      var monthLbl = root.querySelector('.iv__month-lbl');
      var maxroiLbl = root.querySelector('.iv__maxroi-lbl');
      var maxroiSub = root.querySelector('.iv__maxroi-sub');
      var capdaysLbl = root.querySelector('.iv__capdays-lbl');
      var PLANS = [], SEL = null, CFG = null;
      var weekDays = 7, monthDays = 30;
      function usd(n) {
        return '$' + Number(n).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      function usd0(n) {
        return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 0 });
      }
      function mult(n) {
        return String(parseFloat(Number(n).toFixed(2))) + '\xD7';
      }
      function esc(s) {
        return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;'
          }[c];
        });
      }
      function stepOf() {
        var s = CFG ? CFG.investStep : 0;
        return s > 0 ? s : 0;
      }
      function onStep(amount) {
        var s = stepOf();
        if (!s)
          return true;
        return Math.round(amount * 100) % Math.round(s * 100) === 0;
      }
      function stepNeighbours(amount) {
        var s = stepOf();
        if (!s)
          return null;
        var low = Math.floor(amount / s) * s;
        var min = SEL ? SEL.minInvest : s;
        if (low < min)
          low = Math.ceil(min / s) * s;
        return {
          low: low,
          high: low + s
        };
      }
      function renderChips() {
        if (!chipWrap)
          return;
        if (!SEL) {
          chipWrap.innerHTML = '';
          return;
        }
        var base = SEL.minInvest > 0 ? SEL.minInvest : 10;
        var s = stepOf();
        var amts = [
          base,
          base * 5,
          base * 10,
          base * 50
        ];
        var html = '', seen = {};
        for (var i = 0; i < amts.length; i++) {
          var a = amts[i];
          if (s)
            a = Math.ceil(a / s) * s;
          a = Math.round(a * 100) / 100;
          if (a < base)
            continue;
          if (SEL.maxInvest != null && a > SEL.maxInvest)
            continue;
          if (seen[a])
            continue;
          seen[a] = true;
          html += '<button type="button" class="iv__chip" data-amt="' + a + '">' + usd0(a) + '</button>';
        }
        chipWrap.innerHTML = html;
      }
      function planLockLine(p) {
        var bits = [];
        bits.push(p.roiWithdrawable ? 'ROI withdrawable any time' : 'ROI locked until the cycle completes');
        bits.push(p.principalLocked ? 'principal locked until the cycle completes' : 'principal withdrawable any time');
        return bits.join(' \xB7 ');
      }
      var TIER_EMBLEM = {
        silver: '<svg viewBox="0 0 24 24" fill="none"><path d="M12 2.6l7.2 4.16v8.32L12 19.24 4.8 15.08V6.76z" fill="url(#tg-silver)" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/><path d="M12 7.2l3.6 2.08v4.16L12 15.52 8.4 13.44V9.28z" fill="rgba(255,255,255,0.30)"/><defs><linearGradient id="tg-silver" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#eef1f4"/><stop offset="100%" stop-color="#8d949c"/></linearGradient></defs></svg>',
        gold: '<svg viewBox="0 0 32 32" fill="none"><g transform="skewX(-10)"><rect x="6" y="16" width="13" height="7" rx="1.5" fill="url(#tg-g1)"/><rect x="17.5" y="16" width="13" height="7" rx="1.5" fill="url(#tg-g2)"/><rect x="11.8" y="8" width="13" height="7" rx="1.5" fill="url(#tg-g3)"/></g><defs><linearGradient id="tg-g1" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f0d488"/><stop offset="100%" stop-color="#b8923f"/></linearGradient><linearGradient id="tg-g2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#e6c878"/><stop offset="100%" stop-color="#a8853e"/></linearGradient><linearGradient id="tg-g3" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f6e3a8"/><stop offset="100%" stop-color="#c9a969"/></linearGradient></defs></svg>',
        diamond: '<svg viewBox="0 0 24 24" fill="none"><path d="M6.2 3.4h11.6l3.4 5.1L12 20.8 2.8 8.5z" fill="url(#tg-dia)" stroke="currentColor" stroke-width="1.1" stroke-linejoin="round"/><path d="M2.8 8.5h18.4M9 3.4L7.2 8.5 12 20.8 16.8 8.5 15 3.4" stroke="rgba(255,255,255,0.45)" stroke-width="0.9"/><defs><linearGradient id="tg-dia" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#e8fbff"/><stop offset="100%" stop-color="#6fb4cc"/></linearGradient></defs></svg>'
      };
      function tierOf(code) {
        var k = String(code || '').toLowerCase();
        return TIER_EMBLEM[k] ? k : 'gold';
      }
      function renderPlans() {
        if (!planList)
          return;
        if (!PLANS.length) {
          planList.innerHTML = '<div class="iv__plans-loading">No investment plans are open right now. Please try again later.</div>';
          return;
        }
        var html = '';
        PLANS.forEach(function (p) {
          var on = SEL && SEL.code === p.code;
          var tier = tierOf(p.code);
          var short = String(p.name || p.code).replace(/\s*plan\s*$/i, '');
          html += '<button type="button" class="iv__plan-card' + (on ? ' iv__plan-card--on' : '') + '" data-tier="' + tier + '" data-code="' + esc(p.code) + '">' + '<span class="iv__plan-card-sheen"></span>' + '<span class="iv__plan-card-check"><svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4"><polyline points="20 6 9 17 4 12"/></svg></span>' + '<span class="iv__plan-card-emblem">' + TIER_EMBLEM[tier] + '</span>' + '<span class="iv__plan-card-name">' + esc(short) + '</span>' + '<span class="iv__plan-card-roi">' + p.dailyRoi.toFixed(2) + '<i>%</i><small>/day</small></span>' + '<span class="iv__plan-card-rule"></span>' + '<span class="iv__plan-card-cap">' + mult(p.capMultiple) + ' Total Return</span>' + '<span class="iv__plan-card-min">Min ' + usd0(p.minInvest) + '</span>' + '</button>';
        });
        planList.innerHTML = html;
      }
      function renderRules() {
        if (!planRules)
          return;
        if (!SEL) {
          planRules.style.display = 'none';
          return;
        }
        var rows = '';
        rows += '<div class="iv__rule"><span class="iv__rule-ico iv__rule-ico--' + (SEL.roiWithdrawable ? 'ok' : 'lock') + '">' + (SEL.roiWithdrawable ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>' : '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>') + '</span><span class="iv__rule-txt">' + (SEL.roiWithdrawable ? 'Daily ROI can be withdrawn at any time.' : 'Daily ROI stays locked until the ' + mult(SEL.capMultiple) + ' cycle completes.') + '</span></div>';
        rows += '<div class="iv__rule"><span class="iv__rule-ico iv__rule-ico--' + (SEL.principalLocked ? 'lock' : 'ok') + '">' + (SEL.principalLocked ? '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>' : '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>') + '</span><span class="iv__rule-txt">' + (SEL.principalLocked ? 'Principal stays locked until the ' + mult(SEL.capMultiple) + ' cycle completes.' : 'Principal can be withdrawn at any time after the investment starts.') + '</span></div>';
        rows += '<div class="iv__rule"><span class="iv__rule-ico iv__rule-ico--ok">' + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M21 12a9 9 0 1 1-3-6.7"/><polyline points="21 3 21 9 15 9"/></svg>' + '</span><span class="iv__rule-txt">Maximum return is <b>' + mult(SEL.capMultiple) + ' your investment in total</b> \u2014 your capital is part of that figure, not added on top.</span></div>';
        if (SEL.principalFeePct > 0) {
          rows += '<div class="iv__rule"><span class="iv__rule-ico iv__rule-ico--lock">' + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="13"/><circle cx="12" cy="16.5" r="0.8" fill="currentColor" stroke="none"/></svg>' + '</span><span class="iv__rule-txt">Taking your capital out before the cycle completes carries a <b>' + SEL.principalFeePct + '% early-exit charge</b>.</span></div>';
        }
        if (SEL.description) {
          rows += '<div class="iv__rule iv__rule--desc"><span class="iv__rule-txt">' + esc(SEL.description) + '</span></div>';
        }
        planRules.innerHTML = rows;
        planRules.style.display = 'block';
      }
      function renderHero() {
        if (heroRoi)
          heroRoi.textContent = SEL ? SEL.dailyRoi.toFixed(2) + '%' : '\u2014';
        if (heroCap)
          heroCap.textContent = SEL ? mult(SEL.capMultiple) : '\u2014';
        if (heroPay)
          heroPay.textContent = CFG ? CFG.payoutDays.length + '/week' : '\u2014';
      }
      function selectPlan(code) {
        var found = null, want = String(code).toUpperCase();
        for (var i = 0; i < PLANS.length; i++) {
          if (PLANS[i].code === want) {
            found = PLANS[i];
            break;
          }
        }
        if (!found)
          return;
        SEL = found;
        submit.setAttribute('data-plan', SEL.code);
        if (input) {
          input.setAttribute('min', SEL.minInvest);
          var s = stepOf();
          if (s)
            input.setAttribute('step', s);
          else
            input.setAttribute('step', 'any');
        }
        if (minNote) {
          var stepTxt = stepOf() ? ' \xB7 in multiples of <b>' + usd0(stepOf()) + '</b>' : '';
          minNote.innerHTML = 'Minimum <b>' + usd0(SEL.minInvest) + '</b> \xB7 Maximum <b>' + esc(SEL.maxInvestLabel) + '</b>' + stepTxt;
        }
        renderPlans();
        renderRules();
        renderHero();
        renderChips();
        update();
      }
      function update() {
        var amount = parseFloat(input.value);
        var min = SEL ? SEL.minInvest : Infinity;
        var max = SEL && SEL.maxInvest != null ? SEL.maxInvest : Infinity;
        var inRange = !!SEL && !isNaN(amount) && amount >= min && amount <= max;
        var stepOK = !inRange || onStep(amount);
        var valid = inRange && stepOK;
        if (inRange && !stepOK && minNote) {
          var nb = stepNeighbours(amount);
          minNote.innerHTML = '<span class="iv__min-note--err">Enter a multiple of <b>' + usd0(stepOf()) + '</b>' + (nb ? ' \u2014 try <b>' + usd0(nb.low) + '</b> or <b>' + usd0(nb.high) + '</b>' : '') + '.</span>';
        } else if (SEL && minNote) {
          var stepTxt2 = stepOf() ? ' \xB7 in multiples of <b>' + usd0(stepOf()) + '</b>' : '';
          minNote.innerHTML = 'Minimum <b>' + usd0(SEL.minInvest) + '</b> \xB7 Maximum <b>' + esc(SEL.maxInvestLabel) + '</b>' + stepTxt2;
        }
        if (valid) {
          var rate = SEL.dailyRoi / 100;
          var ratePct = SEL.dailyRoi.toFixed(2);
          var daily = amount * rate;
          rateEl.textContent = ratePct + '%';
          dailyEl.textContent = usd(daily);
          weekEl.textContent = usd(daily * weekDays);
          monthEl.textContent = usd(daily * monthDays);
          if (weekLbl)
            weekLbl.textContent = 'Weekly \xB7 ' + weekDays + ' days';
          if (monthLbl)
            monthLbl.textContent = 'Monthly \xB7 ~' + monthDays + ' days';
          var totalOut = amount * SEL.capMultiple;
          var maxRoi = Math.max(0, totalOut - amount);
          var roiMult = Math.max(0, SEL.capMultiple - 1);
          var earnDays = rate > 0 ? Math.ceil(roiMult / rate) : 0;
          var calDays = weekDays > 0 ? Math.ceil(earnDays * 7 / weekDays) : 0;
          var months = (calDays / 30.44).toFixed(1).replace(/\.0$/, '');
          if (maxroiLbl)
            maxroiLbl.textContent = 'Max Return \xB7 ' + mult(SEL.capMultiple);
          if (maxroiSub)
            maxroiSub.textContent = usd(maxRoi) + ' ROI + ' + usd(amount) + ' capital';
          if (capdaysLbl)
            capdaysLbl.textContent = 'Est. Time to ' + mult(SEL.capMultiple);
          maxroiEl.textContent = usd(totalOut);
          capdaysEl.textContent = '~' + calDays.toLocaleString() + ' days';
          capnoteEl.textContent = '\u2248 ' + months + ' months \xB7 ' + (CFG ? CFG.payoutDaysLabel : '');
          capnoteEl.classList.remove('iv__capnote--warn');
          var lockLine = planLockLine(SEL);
          returns.style.display = 'block';
          note.innerHTML = 'Your ' + usd(amount) + ' on the <b>' + esc(SEL.name) + '</b> earns <b>' + ratePct + '% daily</b> up to a total return of <b>' + mult(SEL.capMultiple) + ' your investment</b> (' + usd(totalOut) + '). That total is made up of <b>' + usd(maxRoi) + ' in ROI</b> plus your <b>' + usd(amount) + ' capital</b> \u2014 it is not paid on top. There is no fixed term; it simply runs ' + 'until the cap. ' + esc(lockLine.charAt(0).toUpperCase() + lockLine.slice(1)) + '.';
          submit.classList.remove('disabled');
          submit.setAttribute('data-amount', amount);
        } else {
          returns.style.display = 'none';
          note.innerHTML = '';
          submit.classList.add('disabled');
          submit.removeAttribute('data-amount');
        }
        var chips = root.querySelectorAll('.iv__chip');
        for (var i = 0; i < chips.length; i++) {
          var on = valid && parseFloat(chips[i].getAttribute('data-amt')) === amount;
          chips[i].classList.toggle('iv__chip--on', on);
        }
      }
      if (input)
        input.addEventListener('input', update);
      if (planList) {
        planList.addEventListener('click', function (e) {
          var card = e.target.closest ? e.target.closest('.iv__plan-card') : null;
          if (card)
            selectPlan(card.getAttribute('data-code'));
        });
      }
      if (chipWrap) {
        chipWrap.addEventListener('click', function (e) {
          var chip = e.target.closest ? e.target.closest('.iv__chip') : null;
          if (!chip)
            return;
          input.value = chip.getAttribute('data-amt');
          update();
          input.focus();
        });
      }
      if (window.planConfig) {
        window.planConfig.get(function (cfg) {
          CFG = cfg;
          PLANS = cfg.plans || [];
          weekDays = cfg.payoutDays.length || 7;
          monthDays = Math.round(weekDays * 52 / 12);
          renderHero();
          if (!PLANS.length) {
            renderPlans();
            return;
          }
          selectPlan(PLANS[0].code);
        });
      }
    }
  },
  id: '36831d2dd5',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\r\n  <div class="page iv" data-name="invest">\r\n\r\n    <!-- Navbar -->\r\n    <div class="navbar iv__navbar no-shadow">\r\n      <div class="navbar-bg"></div>\r\n      <div class="navbar-inner">\r\n        <div class="left">\r\n          <a href="#" class="link back iv__back" aria-label="Back">\r\n            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>\r\n          </a>\r\n        </div>\r\n        <div class="title iv__navbar-title">Invest</div>\r\n        <div class="right"></div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class="page-content iv__content">\r\n\r\n      <!-- Plan hero -->\r\n      <div class="iv__plan">\r\n        <div class="iv__plan-glow"></div>\r\n        <div class="iv__plan-shine"></div>\r\n        <div class="iv__plan-head">\r\n          <div class="iv__plan-emblem">\r\n            <svg width="26" height="26" viewBox="0 0 32 32" fill="none">\r\n              <g transform="skewX(-10)">\r\n                <rect x="6" y="16" width="13" height="7" rx="1.5" fill="url(#ivb1)"/>\r\n                <rect x="17.5" y="16" width="13" height="7" rx="1.5" fill="url(#ivb2)"/>\r\n                <rect x="11.8" y="8" width="13" height="7" rx="1.5" fill="url(#ivb3)"/>\r\n              </g>\r\n              <defs>\r\n                <linearGradient id="ivb1" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f0d488"/><stop offset="100%" stop-color="#b8923f"/></linearGradient>\r\n                <linearGradient id="ivb2" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#e6c878"/><stop offset="100%" stop-color="#a8853e"/></linearGradient>\r\n                <linearGradient id="ivb3" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#f6e3a8"/><stop offset="100%" stop-color="#c9a969"/></linearGradient>\r\n              </defs>\r\n            </svg>\r\n          </div>\r\n          <div class="iv__plan-id">\r\n            <div class="iv__plan-name">XAUt Digital Gold</div>\r\n            <div class="iv__plan-sub">Backed by physical gold \xB7 999.9 fine</div>\r\n          </div>\r\n          <div class="iv__plan-live"><span class="iv__plan-live-dot"></span>Live</div>\r\n        </div>\r\n        <div class="iv__plan-stats">\r\n          <div class="iv__stat">\r\n            <div class="iv__stat-val iv__hero-roi">\u2014</div>\r\n            <div class="iv__stat-lbl">Daily ROI</div>\r\n          </div>\r\n          <div class="iv__stat-sep"></div>\r\n          <div class="iv__stat">\r\n            <div class="iv__stat-val iv__hero-cap">\u2014</div>\r\n            <div class="iv__stat-lbl">Max Return</div>\r\n          </div>\r\n          <div class="iv__stat-sep"></div>\r\n          <div class="iv__stat">\r\n            <div class="iv__stat-val iv__hero-payout">\u2014</div>\r\n            <div class="iv__stat-lbl">Payouts</div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Pending-investment notice (shown by routes.js when last investment is processing) -->\r\n      <div class="iv__pending" style="display:none;">\r\n        <span class="iv__pending-ico">\r\n          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><polyline points="12 7 12 12 15 14"/></svg>\r\n        </span>\r\n        <div class="iv__pending-body">\r\n          <div class="iv__pending-title">Investment In Progress</div>\r\n          <div class="iv__pending-sub">Your previous investment is still being processed. You\'ll be able to make a new investment once it\'s activated.</div>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Plan chooser \u2014 populated from the investmentPlans API (never hard-coded) -->\r\n      <div class="iv__plans">\r\n        <div class="iv__plans-head">\r\n          <span class="iv__plans-title">Choose Your Plan</span>\r\n          <span class="iv__plans-sub">Each plan has its own ROI &amp; rules</span>\r\n        </div>\r\n        <div class="iv__plan-list">\r\n          <div class="iv__plans-loading">Loading plans\u2026</div>\r\n        </div>\r\n        <div class="iv__plan-rules" style="display:none;"></div>\r\n      </div>\r\n\r\n      <!-- Amount card -->\r\n      <div class="iv__card">\r\n        <div class="iv__card-label">Investment Amount</div>\r\n        <div class="iv__amount-row">\r\n          <span class="iv__currency">$</span>\r\n          <input type="number" name="amount-invest" id="amount-invest"\r\n            min="10" max="500000000" step="10" placeholder="0.00"\r\n            inputmode="decimal" autocomplete="off"\r\n            class="iv__amount-input" />\r\n        </div>\r\n        <div class="iv__min-note">Select a plan to see its minimum</div>\r\n        <div class="iv__chips"></div>\r\n      </div>\r\n\r\n      <!-- Returns projection -->\r\n      <div class="iv__returns" style="display:none;">\r\n        <div class="iv__returns-head">\r\n          <span class="iv__returns-title">Estimated Daily Earnings</span>\r\n          <span class="iv__returns-badge"><span class="iv__rate">0.60%</span> / day</span>\r\n        </div>\r\n        <div class="iv__returns-range">\r\n          <span class="iv__return-daily">$0.00</span>\r\n          <span class="iv__return-per">/ day</span>\r\n        </div>\r\n        <div class="iv__proj">\r\n          <div class="iv__proj-item">\r\n            <div class="iv__proj-lbl iv__week-lbl">Weekly</div>\r\n            <div class="iv__proj-val iv__week">\u2014</div>\r\n          </div>\r\n          <div class="iv__proj-sep"></div>\r\n          <div class="iv__proj-item">\r\n            <div class="iv__proj-lbl iv__month-lbl">Monthly</div>\r\n            <div class="iv__proj-val iv__month">\u2014</div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class="iv__cap">\r\n          <div class="iv__cap-item">\r\n            <div class="iv__cap-lbl iv__maxroi-lbl">Max Return</div>\r\n            <div class="iv__cap-val iv__maxroi">$0.00</div>\r\n            <div class="iv__cap-sub iv__maxroi-sub">ROI + capital</div>\r\n          </div>\r\n          <div class="iv__cap-sep"></div>\r\n          <div class="iv__cap-item">\r\n            <div class="iv__cap-lbl iv__capdays-lbl">Est. Time to Cap</div>\r\n            <div class="iv__cap-val iv__capdays">\u2014</div>\r\n            <div class="iv__cap-sub iv__capnote"></div>\r\n          </div>\r\n        </div>\r\n\r\n        <p class="iv__returns-note totalReturn"></p>\r\n      </div>\r\n\r\n      <!-- Submit -->\r\n      <button class="iv__submit investNowBTN disabled" type="button">\r\n        <span>Invest Now</span>\r\n        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>\r\n      </button>\r\n\r\n      <div class="iv__tc">\r\n        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>\r\n        By investing you agree to our\r\n        <a href="#" class="popup-open" data-popup="#sheet--invest-tc">Terms &amp; Conditions</a>\r\n      </div>\r\n\r\n      <div class="iv__end-gap"></div>\r\n    </div>\r\n  </div>\r\n';
      return r;
    }(this);
  },
  style: `
/* ════════ INVEST PAGE (iv__*) ════════ */
.iv { background: #0A0A0B !important; }
.iv__content {
  background:
    radial-gradient(130% 45% at 50% 0%, rgba(201,169,105,0.10) 0%, transparent 56%),
    #0A0A0B !important;
  padding: 14px 14px calc(48px + env(safe-area-inset-bottom)) !important;
  margin-top: 60px !important;
}
.iv__navbar { background: linear-gradient(180deg, #100E09 0%, #0B0A07 100%) !important; }
.iv__navbar .navbar-bg { background: transparent !important; }
.iv__navbar-title { color: var(--gold) !important; font-weight: 700; }
.iv__back { color: rgba(201,169,105,0.85) !important; }

/* Pending-investment notice */
.iv__pending {
  display: flex; align-items: flex-start; gap: 12px;
  margin-top: 14px; padding: 15px 16px;
  background: linear-gradient(150deg, rgba(251,191,36,0.12), rgba(251,191,36,0.04));
  border: 1px solid rgba(251,191,36,0.3); border-radius: 16px;
}
.iv__pending-ico {
  flex-shrink: 0; width: 38px; height: 38px; border-radius: 11px;
  background: rgba(251,191,36,0.14); border: 1px solid rgba(251,191,36,0.28); color: #fbbf24;
  display: flex; align-items: center; justify-content: center;
}
.iv__pending-title { font-size: 14px; font-weight: 800; color: #fbbf24; }
.iv__pending-sub { font-size: 12px; color: rgba(255,255,255,0.6); line-height: 1.55; margin-top: 4px; }

/* Plan hero */
.iv__plan {
  position: relative; overflow: hidden;
  background:
    radial-gradient(100% 100% at 100% 0%, rgba(201,169,105,0.16) 0%, transparent 55%),
    linear-gradient(150deg, #221b0d 0%, #161109 55%, #1a150c 100%);
  border: 1px solid rgba(201,169,105,0.24);
  border-radius: 22px; padding: 18px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.20), 0 16px 36px -18px rgba(0,0,0,0.8);
}
.iv__plan::before {
  content: ''; position: absolute; top: 0; left: 10%; right: 10%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.75), transparent);
}
.iv__plan-glow {
  position: absolute; top: -50px; right: -40px; width: 170px; height: 170px;
  border-radius: 50%; pointer-events: none;
  background: radial-gradient(circle, rgba(201,169,105,0.16), transparent 65%);
}
@keyframes iv-shine { 0% { transform: translateX(-130%) skewX(-18deg); } 100% { transform: translateX(420%) skewX(-18deg); } }
.iv__plan-shine { position: absolute; inset: 0; overflow: hidden; border-radius: 22px; pointer-events: none; }
.iv__plan-shine::after {
  content: ''; position: absolute; top: 0; bottom: 0; width: 42%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.05), transparent);
  animation: iv-shine 5.5s ease-in-out infinite 1.5s;
}
.iv__plan-head { position: relative; z-index: 1; display: flex; align-items: center; gap: 11px; }
.iv__plan-emblem {
  width: 46px; height: 46px; border-radius: 13px; flex-shrink: 0;
  background: linear-gradient(145deg, rgba(201,169,105,0.24), rgba(201,169,105,0.08));
  border: 1px solid rgba(201,169,105,0.32);
  display: flex; align-items: center; justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.20);
}
.iv__plan-id { flex: 1; min-width: 0; }
.iv__plan-name { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -0.01em; }
.iv__plan-sub { font-size: 11px; color: rgba(255,255,255,0.42); margin-top: 2px; }
.iv__plan-live {
  display: inline-flex; align-items: center; gap: 5px; flex-shrink: 0;
  font-size: 10px; font-weight: 700; color: #4ADE80;
  background: rgba(74,222,128,0.10); border: 1px solid rgba(74,222,128,0.22);
  border-radius: 20px; padding: 3px 8px;
}
.iv__plan-live-dot { width: 5px; height: 5px; border-radius: 50%; background: #4ADE80; box-shadow: 0 0 5px rgba(74,222,128,0.6); }
.iv__plan-stats {
  position: relative; z-index: 1;
  display: flex; align-items: center;
  margin-top: 16px; padding-top: 15px;
  border-top: 1px solid rgba(201,169,105,0.14);
}
.iv__stat { flex: 1; text-align: center; }
.iv__stat-val { font-size: 16px; font-weight: 800; color: #C9A969; line-height: 1; letter-spacing: -0.01em; }
.iv__stat-lbl { font-size: 10px; color: rgba(255,255,255,0.42); margin-top: 4px; font-weight: 500; }
.iv__stat-sep { width: 1px; height: 30px; background: rgba(201,169,105,0.16); }

/* Amount card */
.iv__card {
  margin-top: 14px;
  background: linear-gradient(155deg, #161513 0%, #121110 100%);
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 20px; padding: 18px;
  box-shadow: inset 0 1px 0 rgba(201,169,105,0.10), 0 14px 30px -18px rgba(0,0,0,0.7);
}
.iv__card-label { font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.55); margin-bottom: 12px; }
.iv__amount-row {
  display: flex; align-items: center; gap: 4px;
  background: var(--bg-input);
  border: 1.5px solid rgba(201,169,105,0.22);
  border-radius: 14px; padding: 0 16px; height: 64px;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.iv__amount-row:focus-within { border-color: var(--gold); box-shadow: 0 0 0 3px rgba(201,169,105,0.12); }
.iv__currency { font-size: 24px; font-weight: 700; color: rgba(201,169,105,0.75); }
.iv__amount-input {
  flex: 1; min-width: 0; height: 100%;
  background: transparent !important; border: none; outline: none;
  color: #fff; font-size: 28px !important; font-weight: 800; letter-spacing: -0.01em !important;
  -webkit-appearance: none; appearance: none;
}
.iv__amount-input::placeholder { color: rgba(255,255,255,0.22); }
.iv__amount-input::-webkit-outer-spin-button,
.iv__amount-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.iv__min-note { font-size: 11px; color: rgba(255,255,255,0.38); margin-top: 8px; }
.iv__min-note b { color: rgba(201,169,105,0.85); }
.iv__min-note--err { color: rgba(255,107,92,0.95); }
.iv__min-note--err b { color: #ff8b7c; }
.iv__chips { display: flex; gap: 8px; margin-top: 14px; }
.iv__chip {
  flex: 1; height: 38px; border-radius: 11px;
  background: rgba(201,169,105,0.08);
  border: 1px solid rgba(201,169,105,0.18);
  color: rgba(201,169,105,0.90); font-size: 12.5px; font-weight: 700; cursor: pointer;
  transition: background 0.15s, border-color 0.15s, color 0.15s, transform 0.1s;
}
.iv__chip:active { transform: scale(0.95); }
.iv__chip--on {
  background: linear-gradient(135deg, rgba(201,169,105,0.30), rgba(201,169,105,0.14));
  border-color: rgba(201,169,105,0.5); color: #f3e0a8;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.25);
}

/* Returns projection */
.iv__returns {
  margin-top: 14px;
  background:
    radial-gradient(100% 80% at 100% 0%, rgba(74,222,128,0.07) 0%, transparent 55%),
    linear-gradient(155deg, #14160f 0%, #111210 100%);
  border: 1px solid rgba(74,222,128,0.18);
  border-radius: 20px; padding: 18px;
}
.iv__returns-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.iv__returns-title { font-size: 12px; font-weight: 600; color: rgba(255,255,255,0.55); }
.iv__returns-badge {
  font-size: 10px; font-weight: 700; color: #4ADE80;
  background: rgba(74,222,128,0.10); border: 1px solid rgba(74,222,128,0.22);
  border-radius: 20px; padding: 2px 8px;
}
.iv__returns-range { display: flex; align-items: baseline; gap: 7px; }
.iv__return-daily { font-size: 26px; font-weight: 800; color: #4ADE80; letter-spacing: -0.01em; }
.iv__return-per { font-size: 12px; color: rgba(255,255,255,0.40); font-weight: 500; }
.iv__rate { font-weight: 800; }
.iv__proj {
  display: flex; align-items: center;
  margin-top: 14px; padding-top: 14px;
  border-top: 1px solid rgba(255,255,255,0.06);
}
.iv__proj-item { flex: 1; min-width: 0; }
.iv__proj-lbl { font-size: 10.5px; color: rgba(255,255,255,0.40); font-weight: 500; }
.iv__proj-val { font-size: 13px; font-weight: 700; color: rgba(255,255,255,0.85); margin-top: 3px; }
.iv__proj-sep { width: 1px; height: 30px; background: rgba(255,255,255,0.08); margin: 0 12px; }

.iv__cap {
  display: flex; align-items: stretch;
  margin-top: 12px; padding: 12px 14px;
  background: linear-gradient(150deg, rgba(201,169,105,0.14), rgba(201,169,105,0.04));
  border: 1px solid rgba(201,169,105,0.26); border-radius: 14px;
}
.iv__cap-item { flex: 1; min-width: 0; }
.iv__cap-lbl { font-size: 10.5px; color: rgba(201,169,105,0.80); font-weight: 600; letter-spacing: 0.02em; }
.iv__cap-val { font-size: 17px; font-weight: 800; color: #dfc288; margin-top: 3px; letter-spacing: -0.01em; }
.iv__cap-sub { font-size: 9.5px; color: rgba(255,255,255,0.42); margin-top: 2px; }
.iv__cap-sub.iv__capnote--warn { color: rgba(239,68,68,0.85); }
.iv__cap-sep { width: 1px; background: rgba(201,169,105,0.22); margin: 0 12px; }
.iv__returns-note { font-size: 11.5px; color: rgba(255,255,255,0.50); line-height: 1.5; margin: 12px 0 0; }
.iv__returns-note b { color: rgba(201,169,105,0.90); font-weight: 700; }

/* ════════ Plan chooser ════════ */
.iv__plans {
  position: relative; overflow: hidden;
  margin-top: 14px;
  background:
    radial-gradient(120% 70% at 50% -10%, rgba(201,169,105,0.10) 0%, transparent 60%),
    linear-gradient(158deg, #17150F 0%, #121110 60%, #141210 100%);
  border: 1px solid rgba(201,169,105,0.20);
  border-radius: 20px; padding: 16px 14px 15px;
  box-shadow: inset 0 1px 0 rgba(223,194,136,0.14), 0 16px 34px -22px rgba(0,0,0,0.85);
}
/* hairline of light across the top edge, matching the plan hero */
.iv__plans::before {
  content: ''; position: absolute; top: 0; left: 12%; right: 12%; height: 1px;
  background: linear-gradient(90deg, transparent, rgba(223,194,136,0.55), transparent);
}
.iv__plans-head { display: flex; align-items: baseline; justify-content: space-between; gap: 10px; margin-bottom: 13px; }
.iv__plans-title {
  font-size: 13.5px; font-weight: 800; color: #fff; letter-spacing: -0.01em;
  display: inline-flex; align-items: center; gap: 7px;
}
.iv__plans-title::before {
  content: ''; width: 3px; height: 13px; border-radius: 2px; flex-shrink: 0;
  background: linear-gradient(180deg, #f3da92, #a07c38);
}
.iv__plans-sub { font-size: 10px; color: rgba(255,255,255,0.38); text-align: right; }
.iv__plans-loading { font-size: 12px; color: rgba(255,255,255,0.40); text-align: center; padding: 18px 4px; }
.iv__plan-list { display: flex; gap: 7px; align-items: stretch; }

/* Per-tier metal palette. Unknown plan codes fall back to the house gold. */
.iv__plan-card {
  --tier-hi: #f6e3a8; --tier: #C9A969; --tier-lo: #a07c38; --tier-rgb: 201,169,105;
}
.iv__plan-card[data-tier="silver"]  { --tier-hi: #f2f5f8; --tier: #C7CBD1; --tier-lo: #868d95; --tier-rgb: 199,203,209; }
.iv__plan-card[data-tier="diamond"] { --tier-hi: #e8fbff; --tier: #9fd8e8; --tier-lo: #5794a8; --tier-rgb: 159,216,232; }

.iv__plan-card {
  position: relative; overflow: hidden;
  flex: 1; min-width: 0;
  display: flex; flex-direction: column; align-items: center;
  padding: 14px 6px 12px; border-radius: 15px; cursor: pointer; text-align: center;
  background: linear-gradient(165deg, rgba(255,255,255,0.05), rgba(255,255,255,0.012));
  border: 1.5px solid rgba(255,255,255,0.07);
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.05);
  transition: background .22s ease, border-color .22s ease, box-shadow .22s ease, transform .16s ease;
}
.iv__plan-card:active { transform: scale(0.97); }

/* emblem */
.iv__plan-card-emblem {
  width: 30px; height: 30px; margin-bottom: 7px;
  display: flex; align-items: center; justify-content: center;
  color: rgba(var(--tier-rgb), 0.75);
  filter: grayscale(0.55) opacity(0.65);
  transition: filter .22s ease, transform .22s ease;
}
.iv__plan-card-emblem svg { width: 100%; height: 100%; }

.iv__plan-card-name {
  font-size: 11px; font-weight: 800; letter-spacing: 0.05em; text-transform: uppercase;
  color: rgba(255,255,255,0.55);
  transition: color .22s ease;
}
.iv__plan-card-roi {
  margin-top: 5px;
  font-size: 20px; font-weight: 800; line-height: 1; letter-spacing: -0.02em;
  color: rgba(255,255,255,0.72);
  font-variant-numeric: tabular-nums;
  transition: color .22s ease;
}
.iv__plan-card-roi i { font-style: normal; font-size: 12px; font-weight: 700; margin-left: 1px; opacity: 0.8; }
.iv__plan-card-roi small { display: block; font-size: 8.5px; font-weight: 600; letter-spacing: 0.04em; opacity: 0.5; margin-top: 3px; text-transform: uppercase; }
/* hairline divider under the rate */
.iv__plan-card-rule {
  width: 26px; height: 1px; margin: 9px 0 8px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.16), transparent);
  transition: background .22s ease, width .22s ease;
}
.iv__plan-card-cap { font-size: 9.5px; font-weight: 700; color: rgba(255,255,255,0.45); letter-spacing: 0.01em; }
.iv__plan-card-min { font-size: 9px; color: rgba(255,255,255,0.26); margin-top: 3px; }

.iv__plan-card-check {
  position: absolute; top: 7px; right: 7px; z-index: 2;
  width: 15px; height: 15px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  background: linear-gradient(145deg, var(--tier-hi), var(--tier-lo));
  color: #14100a; opacity: 0; transform: scale(0.5) rotate(-25deg);
  box-shadow: 0 2px 7px rgba(0,0,0,0.45);
  transition: opacity .22s ease, transform .22s cubic-bezier(.34,1.56,.64,1);
}

/* slow sheen sweep, selected card only */
@keyframes iv-plan-sheen { 0% { transform: translateX(-130%) skewX(-20deg); } 60%,100% { transform: translateX(320%) skewX(-20deg); } }
.iv__plan-card-sheen { position: absolute; inset: 0; pointer-events: none; overflow: hidden; border-radius: 15px; }
.iv__plan-card--on .iv__plan-card-sheen::after {
  content: ''; position: absolute; top: 0; bottom: 0; width: 45%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.10), transparent);
  animation: iv-plan-sheen 4.5s ease-in-out infinite 1s;
}

/* ── selected ── */
.iv__plan-card--on {
  background:
    radial-gradient(105% 75% at 50% 0%, rgba(var(--tier-rgb), 0.26) 0%, transparent 62%),
    linear-gradient(168deg, rgba(var(--tier-rgb), 0.14), rgba(255,255,255,0.02));
  border-color: rgba(var(--tier-rgb), 0.62);
  box-shadow:
    0 12px 26px -14px rgba(var(--tier-rgb), 0.55),
    inset 0 1px 0 rgba(255,255,255,0.22);
  transform: translateY(-2px);
}
.iv__plan-card--on:active { transform: translateY(-2px) scale(0.97); }
.iv__plan-card--on .iv__plan-card-check { opacity: 1; transform: scale(1) rotate(0); }
.iv__plan-card--on .iv__plan-card-emblem { filter: none; transform: scale(1.06); }
.iv__plan-card--on .iv__plan-card-name { color: #fff; }
.iv__plan-card--on .iv__plan-card-roi {
  background: linear-gradient(180deg, var(--tier-hi), var(--tier));
  -webkit-background-clip: text; background-clip: text;
  -webkit-text-fill-color: transparent; color: transparent;
}
.iv__plan-card--on .iv__plan-card-rule { width: 34px; background: linear-gradient(90deg, transparent, rgba(var(--tier-rgb), 0.75), transparent); }
.iv__plan-card--on .iv__plan-card-cap { color: rgba(255,255,255,0.82); }
.iv__plan-card--on .iv__plan-card-min { color: rgba(255,255,255,0.42); }

/* ── Selected-plan rules ── */
.iv__plan-rules {
  margin-top: 14px; padding: 12px 13px;
  background: rgba(0,0,0,0.22);
  border: 1px solid rgba(255,255,255,0.05);
  border-radius: 13px;
}
.iv__rule { display: flex; align-items: flex-start; gap: 9px; margin-top: 9px; }
.iv__rule:first-child { margin-top: 0; }
.iv__rule-ico {
  flex-shrink: 0; width: 20px; height: 20px; border-radius: 7px; margin-top: 0.5px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.10);
}
.iv__rule-ico--ok   { background: rgba(74,222,128,0.14); color: #4ADE80; border: 1px solid rgba(74,222,128,0.22); }
.iv__rule-ico--lock { background: rgba(251,191,36,0.14); color: #fbbf24; border: 1px solid rgba(251,191,36,0.24); }
.iv__rule-txt { font-size: 11.5px; color: rgba(255,255,255,0.60); line-height: 1.55; }
.iv__rule-txt b { color: rgba(223,194,136,0.95); font-weight: 700; }
.iv__rule--desc { padding-left: 29px; margin-top: 10px; padding-top: 9px; border-top: 1px solid rgba(255,255,255,0.05); }
.iv__rule--desc .iv__rule-txt { color: rgba(255,255,255,0.40); font-style: italic; }

/* Submit */
@keyframes iv-btn-shine { 0% { left: -60%; } 55%,100% { left: 130%; } }
.iv__submit {
  position: relative; overflow: hidden;
  width: 100%; height: 54px; margin-top: 18px; border: none; border-radius: 15px;
  background: linear-gradient(135deg, #f3da92 0%, #C9A969 45%, #a07c38 100%);
  color: #1a1206; font-size: 15px; font-weight: 800;
  display: flex; align-items: center; justify-content: center; gap: 8px; cursor: pointer;
  box-shadow: 0 10px 26px -8px rgba(201,169,105,0.6), inset 0 1px 0 rgba(255,255,255,0.4);
  transition: transform 0.14s, opacity 0.2s, filter 0.2s;
}
.iv__submit::after {
  content: ''; position: absolute; top: 0; bottom: 0; left: -60%; width: 38%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent);
  transform: skewX(-20deg); animation: iv-btn-shine 4s ease-in-out infinite;
}
.iv__submit span, .iv__submit svg { position: relative; z-index: 1; }
.iv__submit:active { transform: scale(0.98); }
.iv__submit.disabled {
  opacity: 0.45; filter: grayscale(0.3); pointer-events: none; box-shadow: none;
}
.iv__submit.disabled::after { display: none; }

.iv__tc {
  display: flex; align-items: center; justify-content: center; gap: 6px; flex-wrap: wrap;
  margin-top: 16px; font-size: 11.5px; color: rgba(255,255,255,0.42); text-align: center;
}
.iv__tc svg { color: rgba(201,169,105,0.55); }
.iv__tc a { color: var(--gold); font-weight: 600; }
.iv__end-gap { height: 50px; }
`,
  styleScoped: false
};